import classNames from 'classnames';
import { StatDisplay, StatDisplayProps } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { formatDirectionToCompassPoint } from './formatDirectionToCompassPoint';
import './StatWithDirection.scss';
import { DynamicDirectionIcon } from 'app/agriculture/components/StatWithDirection/DynamicDirectionIcon/DynamicDirectionIcon';

interface StatWithDirectionProps extends StatDisplayProps {
    /**
     * Direction angle in degrees, clockwise from up/north.
     *
     * @default 0 (pointing up/north)
     */
    direction?: number | null;
    value?: string | number | null;
    directionOnly?: boolean;
}

export function StatWithDirection({
    direction,
    value,
    className,
    directionOnly = false,
    ...statDisplayProps
}: StatWithDirectionProps) {
    const compassDirection = formatDirectionToCompassPoint(direction ?? null, {
        includeHalfWinds: true,
    });

    const getDisplayValue = () => {
        if (direction == null) {
            return value;
        }
        return directionOnly ? compassDirection : `${compassDirection} ${value}`;
    };

    return (
        <StatDisplay
            {...statDisplayProps}
            value={getDisplayValue()}
            className={classNames(className, 'StatWithDirection')}
            Icon={(props) => <DynamicDirectionIcon {...props} direction={direction ?? undefined} />}
        />
    );
}
